import { render, staticRenderFns } from "./DefaultSkeletonLoader.vue?vue&type=template&id=92e610fa"
import script from "./DefaultSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./DefaultSkeletonLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports